// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uKhkg","content":"styles_content__V4p10","tableWrap":"styles_tableWrap__1eVTq"};